import { Icon, IconButton } from '@chakra-ui/react'
import React from 'react'
import { FaEdit } from 'react-icons/fa'

interface Props {
    name: string
    label: string
    onClick: () => void
}

export const EditButton: React.FC<Props> = ({ name, label, onClick }) => {
    return (
        <IconButton
            id={name}
            aria-label={label}
            ml="10px"
            mt="-2px"
            variant={'ghost'}
            size="xs"
            color="smTextSecondary"
            icon={<Icon as={FaEdit} w="15px" h="15px" />}
            onClick={onClick}
        />
    )
}
